import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthProvider';

const ProtectedRoute = ({ children, access_requirement }) => {
  const { isAuthenticated, permissions } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      // Redirect to login if not authenticated
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);
  
  useEffect(() => {
    if (access_requirement && permissions[access_requirement] !== 'WRITE' && permissions[access_requirement] !== 'READ') {
      navigate('/home')
    }
  }, [permissions, navigate, access_requirement])

  return isAuthenticated ? children : null; // Render children if authenticated
};

export default ProtectedRoute;